import {NgModule} from '@angular/core';
import {InjectionsComponent} from './injections.component';
import {InjectionComponent} from './injection/injection.component';
import {InjectionService} from './injection/injection.service';
import {InjectionsService} from './injections.service';

@NgModule({
    declarations: [
        InjectionComponent,
        InjectionsComponent
    ],
    entryComponents: [
        InjectionComponent,
        InjectionsComponent
    ],
    exports: [
        InjectionComponent,
        InjectionsComponent
    ],
    providers: [
        InjectionService,
        InjectionsService
    ]
})
export class InjectionsModule {
}
